import React from 'react';
import Header from './Header';
import Footer from './Footer';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
            <Header />

            {/* Main content with top padding for fixed header */}
            <main className="pt-20">
                {children}
            </main>

            <Footer />
        </div>
    );
};

export default Layout;